import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const ecommerceHtml =
'<div class="form-group text-left mt-2">' +
  '<label for="ecommerce-ecommerce-store"> ' + lang.ecommerce_html_label_store + ' </label>' +
  '<select id="ecommerce-ecommerce-store" class="form-control select2">' +
    '<option value="">' + lang.ecommerce_html_title_select + '</option>' +
  '</select>' +
'</div>' +

'<div id="ecommerce-ecommerce-product-group" class="ecommerce-onDemand-field form-group text-left mt-3">' + 
'<label for="ecommerce-ecommerce-product"> ' + lang.ecommerce_html_label_products + ' </label>' +
'<select id="ecommerce-ecommerce-product" class="form-control select2" multiple>' +
'</select>' +
'</div>' +

'<div id="ecommerce-ecommerce-button-text-group" class="ecommerce-onDemand-field form-group text-left mt-2">' + 
'<label for="ecommerce-ecommerce-button-text"> ' + lang.ecommerce_html_label_button_name + ' </label>' +
'<input type="text" class="form-control" id="ecommerce-ecommerce-button-text" aria-describedby="ecommerce-ecommerce-button-text-help">' +
'</div>' +

// Adds html for delay system
delayHtml
